import {Injectable} from "@angular/core";
import {DataService} from "../shared/data.service";
import {EMPTY, of} from "rxjs";
import {ApiEndpoints} from "../shared/ApiEndpoints";

@Injectable()
export class InterfaceService extends DataService{

  getItems() {
    return this.getRequest(ApiEndpoints.interface);
  }

  getItem(id) {
    return this.getRequest(`${ApiEndpoints.interface}/${id}`)
  }

  uploadFile(interfaceID, formData) {
    return this.uploadRequest(`${ApiEndpoints.interface}/upload/${interfaceID}`, formData);
  }
}
